import axios from './Api';


export function GetAdditionsRange(params: {} = {}) {
  return axios.get<Additions.IAdditionsRange[]>('/additions/range', { params });
}

export function DeleteAddition(additionId: number = 0) {
  return axios.delete(`/additions/${additionId}`);
}

export function CreateAddition(data: Additions.IAdditions) {
  return axios.post<Additions.IAdditionsCreate>('/additions', data);
}

export function UpdateAddition(additionId: string | number = '', data: Additions.IAdditions) {
  return axios.put<Additions.IAdditionsCreate>(`/additions/${additionId}`, data);
}

export function GetAdditions(additionId: string | number = '', params: {} = {}) {
  return axios.get<Additions.IAdditions[]>(`/additions/${additionId}`, { params });
}

export function GetAdditionForBackOffice(data = {} as Aid.IGetAidsForBackOffice) {
  return axios.post<Aid.IGetAidForBackOffice[]>('/additions/association/consumption', data);
}

export function GetConsumptionPointInterval(consumptionPoint = '') {
  return axios.get<Aid.IAidConsumptionPointInterval[]>(`/additions/association/consumptionPointInterval/${consumptionPoint}`);
}

export function CreateInterval(aidInterval: Aid.ICreateAidConsumptionPointInterval) {
  return axios.post<Aid.ICreateAidConsumptionPointInterval>('/additions/association/consumptionPointInterval', aidInterval);
}

export function EditInterval(aidInterval: Aid.ICreateAidConsumptionPointInterval) {
  return axios.put<Aid.ICreateAidConsumptionPointInterval>(
    `/additions/association/consumptionPointInterval/${aidInterval.consumptionPointIntervalId}`,
    aidInterval
  );
}

export function SaveAdditionsInterval(consumptionPoint = '', additions: Aid.ISaveAidConsumptionPointInterval[]) {
  return axios.post<Axios.IResponseSuccess>(`/additions/association/consumption/${consumptionPoint}`, additions);
}

export function ModifyAdditionsInterval(consumptionPoint = '', additions: Aid.ISaveAidConsumptionPointInterval[]) {
  return axios.put<Axios.IResponseSuccess>(`/additions/association/consumption/${consumptionPoint}`, additions);
}

export function ExportAssociationReport(data = {} as Aid.IAidAssociationExport) {
  return axios.post<Aid.IAidExportPartnerResponse>('/additions/association/export', data, { responseType: 'blob' });
}

export function AdditionCalculate(data = {} as Aid.IAidCalculate) {
  return axios.post<Aid.IAidCalculateResponse>('/additions/association/calculate', data);
}
